<template v-once>
  <textarea
    v-if="mode === 'textarea'"
    v-model="value"
    :autofocus="autofocus"
    :disabled="disabled"
  />
  <input
    v-else
    v-model="value"
    :autofocus="autofocus"
    :disabled="disabled"
    @change="onChange"
  >
</template>

<script>
  import Tagify from "@yaireo/tagify/dist/tagify.min.js"
  import "@yaireo/tagify/dist/tagify.css"
  // import { matchSorter } from 'match-sorter'

  export default {
    name: "Tagify",
    props: {
      mode: String,
      settings: Object,
      value: String,
      whitelist: Array,
      onChange: Function,
      onInput: Function,
      allowNew: Boolean,
      autofocus: Boolean,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value(newVal) {
        if (newVal) {
          const oldVal = this.tagify.value.map((tag) => tag.value)
          const newValArr = newVal.split(',')
          const toRemove = oldVal.filter(x => !newValArr.includes(x));
          let tags = []
          newValArr.forEach((tag) => {
            if(!this.tagify.isTagDuplicate(tag))
              tags.push(tag)
          })
          this.tagify.removeTags(toRemove)
          this.tagify.addTags(tags)
        } else {
          this.tagify.removeAllTags()
        }
      },
      whitelist(newVal) {
        let availableTags = [...newVal]
        availableTags.sort((a, b) => a.localeCompare(b))

        if (this.value != undefined) {
          this.tagify.whitelist = availableTags.concat(this.value.split(','))
        }
      },
    },
    mounted() {
      this.tagify = new Tagify(this.$el, this.settings)
      this.tagify.settings.enforceWhitelist = !this.allowNew

      // this.tagify.on('change', e => this.$emit('tagClicked', e.detail))
      // this.tagify.on('input', (e) => {
      //   this.tagify.whitelist = null; // reset current whitelist
      //   this.tagify.loading(true)
      //   this.tagify.settings.whitelist = matchSorter(this.whitelist, e.detail.value)
      //   this.tagify.loading(false)//.dropdown.show(e.detail.value);
      // })
      this.tagify.on('keydown', (e) => {
        if( e.detail.originalEvent.key == 'Enter' &&         // "enter" key pressed
            this.tagify.state.inputText == '' &&  // assuming user is not in the middle oy adding a tag
            !this.tagify.state.editing       // user not editing a tag
          ){
          // console.log('tagify emitting')
          this.$emit('submit')
        }
      })
    }
  }
</script>

<style lang="scss">

</style>
